/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polygon } from 'react-leaflet';
import AppContext from 'context/Context';
import 'leaflet.tilelayer.colorfilter';
import 'leaflet/dist/leaflet.css';
import '@changey/react-leaflet-markercluster/dist/styles.min.css';
import { isEmpty } from 'lodash';
import GeoTiffLayer from './GeoTiffLayer';
import { getColorScale, legendTitle } from 'helpers/leaflet-utils';
import Legend from 'components/common/map/Legend';

const LeafletMap = ({ data, index, ...rest }) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);

  const { coordinates, mapData } = data;
  const [indexScale, setIndexScale] = useState([]);
  const [layerVisible, setLayerVisible] = useState(true);

  useEffect(() => {
    setIndexScale(getColorScale(mapData.title));
  }, [data]);

  if (isEmpty(mapData.tifUrl)) {
    return null;
  }
  const position = coordinates[0];
  const fillColor = {
    color: 'white',
    fillColor: '#fff',
    opacity: 1,
    fillOpacity: 0
  };
  const tiffUrl = mapData.tifUrl;

  const environmentMap = [
    'Carbon Flux Emission',
    'Carbon Flux Removal',
    'Net Carbon Flux'
  ];
  const isEnvironmentMap = environmentMap.includes(mapData.title);

  const legendTitleMap = isEmpty(legendTitle[mapData.title])
    ? mapData.title
    : legendTitle[mapData.title];

  return (
    <MapContainer
      zoom={isRTL ? 1.8 : 1.5}
      minZoom={isRTL ? 1.8 : 1.3}
      zoomSnap={0.5}
      center={position}
      {...rest}
      radius={200}
    >
      <TileLayer
        attribution='Google Maps &copy; <a href="https://farmsio.com">Farmsio</a>'
        url="https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
      />
      {!isEmpty(data.coordinates) && (
        <Polygon pathOptions={fillColor} positions={data.coordinates} />
      )}
      {!isEmpty(tiffUrl && indexScale) && (
        <GeoTiffLayer
          url={tiffUrl}
          title={mapData.title}
          coordinates={coordinates}
          layerVisible={layerVisible}
        />
      )}
      {!isEmpty(indexScale) && (
        <Legend
          indexScale={indexScale}
          title={legendTitleMap}
          setLayerVisible={setLayerVisible}
          header={isEnvironmentMap ? false : true}
        />
      )}
    </MapContainer>
  );
};

export default LeafletMap;
